export default {
  /*更新用户登录信息，当loginMessage值为null时清空登录信息*/
  UPDATELOGININFO (state, loginMessage) {
    state.userLoginMessage = loginMessage;
    if (loginMessage) {               //登录操作
      if (window.localStorage.hasOwnProperty('userLoginMessage')) {
        let obj1 = window.localStorage.getItem('userLoginMessage')
        // 比对权限，门店
        if (JSON.stringify(loginMessage) != obj1) {
          window.localStorage.setItem('userLoginMessage', JSON.stringify(loginMessage))
        }
      } else {
        window.localStorage.setItem('userLoginMessage', JSON.stringify(loginMessage))
      }
    } else {                          //退出登录操作
      window.localStorage.removeItem('userLoginMessage')
    }
  },
  /*更新用户消息列表*/
  UPDATEMSGLIST (state,arr) { state.msgLists = {...state.msgLists,...arr}; },
  /*更新用户未读消息总数*/
  UPDATEUNREAD (state,numInfo) {
    state.unReadTrade = numInfo;
  },
  /*消息详情*/
  UPDATEMSGDETAIL (state,info) { state.msgDetail = info;},
  /*更新用户会员中心头部内容*/
  UPDATEUSERHEAD (state,info) { state.userHeadInfo =info;},
  /*更新用户职位列表*/
  UPDATEPOSITIONLISTS(state,lists) { state.positionLists = {...state.positionLists,...lists}; },
  /*更新销售关联酒店列表*/
  UPDATESALESASSOCIATIONLISTS(state,lists) { state.salesAssociationLists = {...state.salesAssociationLists,...lists}; },
  /*更新用户的所有权限节点*/
  UPDATEUSERACCESSLISTS (state,lists) { state.accessLists = lists; },
  /*更新用户某一职位的详细信息*/
  UPDATEPOSITIONDETAIL (state,info) { state.positionDetail = info; },
  /*更新用户(子)账号列表*/
  UPDATESTAFFLISTS (state,lists) { state.staffLists = lists; },
  /*更新用户账号架构数组*/
  UPDATESTRUCTURE (state,lists) { state.accountStructure = lists; },
  /*更新用户某一员工信息详情*/
  UPDATESTAFFDETAIL (state,info) { state.staffDetail = info; },
  /*更新用户微信绑定信息*/
  UPDATEWECHATINFO (state,info) { state.wechatInfo = info; },
  /*更新用户中心首页数据*/
  UPDATEINDEXDATA (state,info) { state.IndexData = info; },
  /*更新用户待处理数据*/
  UPDATEWAITVERIFY(state,info) { state.waitVerify = {...state.waitVerify,...info}; },
  /*更新ELUI表单最大值最小值*/
  ELFORMVALUE(state,info) { state.elFormValue = {...state.elFormValue,...info}; },
}
